// eslint-disable-next-line import/prefer-default-export
export enum ResonanceShippingMethod {
    Ground = "GROUND",
    ThreeDay = "THREE_DAY",
    TwoDay = "TWO_DAY",
    Overnight = "OVERNIGHT",
}
